import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link as RouterLink } from 'react-router-dom'

import T from '../../../translate/T'

import style from './style.css'

import SearchFilter from '../../molecules/SearchFilter'
import Font from '../../atoms/Font'
import Link from '../../atoms/Link'
import Loading from '../../atoms/Loading'

import BoxEvent from '../../molecules/BoxEvent'

import Carousel from '../../third-party/SlickCarousel'
import { Col } from '../../atoms/Grid'
import FeaturedEvents from '../../molecules/FeaturedEvents'
import { numberFormat } from '../../../libraries/Formatter'
import ActionBtnIcon from '../../molecules/ActionBtnIcon'
import Avatar from '../../atoms/Avatar'


import * as events from '../../../utils/events'
import * as experiences from '../../../utils/experiences'
import * as users from '../../../utils/users'

class Search extends Component {

    state = {
        filter: '',
        events_status: 'not_loaded',
        experiences_status: 'not_loaded',
        athletes_status: 'not_loaded',
        events: [],
        experiences: [],
        athletes: []
    }

    componentWillMount() {
        this.setState({
            filter: '',
            events_status: 'not_loaded',
            experiences_status: 'not_loaded',
            athletes_status: 'not_loaded',
            events: [],
            experiences: [],
            athletes: []
        })
    }

    handleFilter(data) {
        if(data.filter === '') return false

        this.setState({
            events_status: data.events === true ? 'loading' : 'not',
            experiences_status: data.experiences === true ? 'loading' : 'not',
            athletes_status: data.athletes === true ? 'loading' : 'not',
            filter: data.filter,
            events: [],
            experiences: [],
            athletes: []
        })
        
        if(data.events === true) {
            events.filter(data.filter)
            .then(resp => {
                this.setState({
                    events_status: 'done',
                    events: resp.result
                })
            })
        }

        if(data.experiences === true) {    
            experiences.filter(data.filter)
            .then(resp => {
                this.setState({
                    experiences_status: 'done',
                    experiences: resp.result
                })
            })
        }

        if(data.athletes === true) {    
            users.filter(data.filter)
            .then(resp => {
                this.setState({
                    athletes_status: 'done',
                    athletes: resp.result
                })
            })
        }

    }

    handleStatus() {
        let events_status = this.state.events_status
        let experiences_status = this.state.experiences_status
        let athletes_status = this.state.athletes_status
        if(
            events_status === 'not_loaded'
            || experiences_status === 'not_loaded'
            || athletes_status === 'not_loaded'
        ) return 'not_loaded'

        if(
            events_status === 'loading'
            || experiences_status === 'loading'
            || athletes_status === 'loading'
        ) return 'loading'

        if(
            (events_status === 'done' || events_status === 'not')
            && (experiences_status === 'done' || experiences_status === 'not')
            && (athletes_status === 'done' || athletes_status === 'not')
        ) {
            let total = this.state.events + this.state.experiences + this.state.athletes
            if(total > 0) {
                return 'not_found'
            } else {
                return 'done'
            }
        }
    }

    followUser(key) {
        let usersList = this.state.athletes
        let user = usersList[key]
        user.followed = "1"
        usersList[key] = user

        users.toggleFollow(user.id_user)
        this.setState({
            athletes: usersList
        })
    }

    render() {
      return (
        <div>
            <Col>
                <br /><br />
                <SearchFilter onSubmit={ data => {
                    this.handleFilter(data)
                } } placeholder={T.txt('placeholder_search')}/>
            </Col>

            { this.handleStatus() === 'loading' && (
                <Loading />    
            )}
            
            { this.handleStatus() === 'done' && (
                <div className={`${style.wrapresults}`}>
                    <Col>
                        <Font heading='3' color='#666666' weight="100">
                            {T.text('search_find_result', {
                                results: this.state.events.length + this.state.experiences.length + this.state.athletes.length,
                                filter: this.state.filter
                            })}
                        
                        </Font>
                    </Col>
                    
                    {this.state.events_status !== 'not' && (
                    
                        <Col>
                            <Font heading="4" weight="100" color="#666">
                            
                            {T.text('search_headline_events')}
                            </Font>
                            {this.state.events.length === 0 ? (
                                <span>{T.text('search_not_found_events')}</span>
                            ) : (
                                <Carousel itens={2} centerPadding='0'>
                                    { this.state.events.map(item => (
                                    <Col key={item.token}>
                                        <RouterLink onClick={() => {
                                            if(this.props.handleRouterLink)
                                                this.props.handleRouterLink()
                                        }} to={`/event/${item.token}`}>
                                            <BoxEvent data={item} />
                                        </RouterLink>
                                    </Col>
                                    ))}
                                </Carousel>                            
                            )}
                        </Col>
                    )}
                    
                    {this.state.experiences_status !== 'not' && (
                        <Col>
                            <Font heading="4" weight="100" color="#666">
                            {T.text('search_headline_experiences')}
                            </Font>
                            {this.state.experiences.length === 0 ? (
                                <span>{T.text('search_not_found_experiences')}</span>                                
                            ) : (
                                <Carousel itens="4" arrows={false} centerPadding='0'>
                                    { this.state.experiences.map(experience => (
                                        <Col key={experience.id}>
                                            <RouterLink onClick={() => {
                                                if(this.props.handleRouterLink)
                                                    this.props.handleRouterLink()
                                            }} to={`/experience/${experience.token}`}>
                                                <FeaturedEvents cover={experience.cover} exp={parseInt(experience.difficulty, 10)} name={experience.title} price={`R$ ${numberFormat(experience.starting_from, 2, ',', '.')}`}/>
                                            </RouterLink>
                                        </Col>
                                    )) }
                                    
                                </Carousel>
                            )}
                        </Col>
                    )}

                    {this.state.athletes_status !== 'not' && (
                        <Col>
                            <Font heading='4' color='#666666' weight="100">{T.text('search_headline_athletes')}</Font>
                            {this.state.athletes.length === 0 ? (
                                <span>{T.text('search_not_found_athletes')}</span>
                            ) : (
                                <div>
                                    {this.state.athletes.map( (user, key) => (
                                        <Col key={user.user_uri} size={2} className={`${style.follower}`}>
                                            { this.props.login.isLogged && (
                                                <span className={style.iconAction}>
                                                    { user.followed === "0" &&
                                                        <ActionBtnIcon theme="rounded-orange" action={(e) => {
                                                                                                                this.followUser(key)
                                                                                                            }} icon='add-user' />
                                                    }
                                                    { user.followed === "1" &&
                                                        <ActionBtnIcon theme="success" icon='check-o' />
                                                    }
                                                </span>
                                            )}
                                            <Avatar href={`${window.config.url_base_old}${user.user_uri}`} size={90} img={user.avatar ? `${window.URL_ASSETS_BASE}${user.avatar}` : ''} />
                                            <Link href={`${window.config.url_base_old}${user.user_uri}`}>
                                            {user.name}
                                            </Link>
                                        </Col>
                                    ))}
                                </div>
                            )}
                        </Col>
                    )}
                </div>
            )}
        </div>
      )
    }
  }
  
const mapStateToProps = state => ({
    login: state.login
})
const mapDispatchToProps = dispatch => bindActionCreators({  
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Search)


// WEBPACK FOOTER //
// ./src/components/container/Search/index.js